module.exports = __webpack_public_path__ + "img/mobile_qr_code.cc4a2192.svg";